import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';

import useReadAllNotifications from './hooks/useReadAllNotifications';

interface Props {
    isBlank: boolean;
}

function NotificationTitle({ isBlank }:Props) {
  const readAll = useReadAllNotifications();
  return (
        <Container
             justify='space-between'
             fullWidth
             align='center' >
            <Text size='3xl' fontWeight='bold'>
                알림
            </Text>
            {(!isBlank) && (
                <ReadButton onClick={readAll}>
                    전체 읽음
                </ReadButton>
            )}
        </Container>
  );
}

const Container = styled(Row)`
    padding: 8px 18px;
`;

const ReadButton = styled.button`
    padding: 6px 16px;
    background-color: transparent;
    border: 1px solid var(--color-gray3);
    border-radius:100px;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-gray7);
`;

export default NotificationTitle;
